import { centsToDollarString } from '@perch-labs/warbler';
import { DECLINED_STATUS } from 'domain/payment-method';
import { copyFor } from 'config';
import {
  PlanPaymentMethod,
  PlanStatement,
  isExpiring,
  isExpired,
} from '../../../payment-methods.utils';

const getPaymentMethodCopy = copyFor(
  'settings.paymentInformation.paymentMethods'
);

interface Props {
  paymentMethod: PlanPaymentMethod;
  mostRecentStatement: PlanStatement;
  utilityBilled: boolean;
}

const showDeclineError = ({
  paymentMethod,
  mostRecentStatement,
}: Props): boolean => {
  const { status, paymentMethodId } =
    mostRecentStatement?.mostRecentPaymentTransaction || {};
  return status === DECLINED_STATUS && paymentMethodId === paymentMethod?.id;
};

export const getPlanPaymentError = ({
  paymentMethod,
  mostRecentStatement,
  utilityBilled,
}: Props): string | undefined => {
  if (utilityBilled) {
    return undefined;
  } else if (!paymentMethod) {
    return getPaymentMethodCopy('errors.noPaymentMethod');
  } else if (
    showDeclineError({ paymentMethod, mostRecentStatement, utilityBilled })
  ) {
    return getPaymentMethodCopy('errors.transactionError', {
      description: paymentMethod?.description,
      total: centsToDollarString(mostRecentStatement?.total || 0),
    });
  } else if (isExpired(paymentMethod)) {
    return getPaymentMethodCopy('errors.expiredPaymentMethod.long');
  } else if (isExpiring(paymentMethod)) {
    return getPaymentMethodCopy('errors.expiringPaymentMethod.long');
  }
};
